import {
  PlaystudiosStoreRefreshPopupWithProducts,
  StoreRefreshPopupWithProducts
} from '@appcharge/shared-ui';

import { EThemes, ETriggeredPopupsInternalViewModel } from '../enums';

import { BlockMetadata } from './types';

const defaultTriggeredPopup: BlockMetadata = {
  id: ETriggeredPopupsInternalViewModel.DEFAULT,
  version: '1.0.0',
  name: 'Default',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/popups/trigger-popup-royal-blast.png'
  ],
  theme: EThemes.ROYAL_BLAST,
  component: StoreRefreshPopupWithProducts
};

const defaultKonamiSlots: BlockMetadata = {
  id: ETriggeredPopupsInternalViewModel.KONAMI_SLOTS,
  version: '1.0.0',
  name: 'Konami Slots',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/popups/trigger-popup-konami.png'
  ],
  theme: EThemes.PLAYSTUDIOS,
  component: PlaystudiosStoreRefreshPopupWithProducts
};

export const triggeredPopupsDesigns = {
  defaultTriggeredPopup,
  defaultKonamiSlots
};

export const triggeredPopupsDesignsByTheme: Record<EThemes, BlockMetadata[]> =
  Object.values(triggeredPopupsDesigns).reduce(
    (acc, design) => {
      if (!acc[design.theme]) {
        acc[design.theme] = [];
      }
      acc[design.theme].push(design);
      return acc;
    },
    {} as Record<EThemes, BlockMetadata[]>
  );
